module.exports = __webpack_public_path__ + "img/prod-icon3.20fc2861.png";